<template>
  <div class="sidebar-pinned ">
    <Navbar/>

    <main class="admin-main">
    <!--site header begins-->

   <section class="admin-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-home" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Hello, {{ auth_user.user.firstname }}</h4>
              <small style="opacity: .8;">Your coverage, facility and requests</small>
            </div>
          </div>
        </div>
      </div>
        <div class="container mt-n3 pb-5">

            <div class="row">

              <div class="row col-md-12" >
                <div class="col-md-6">
                  <div class="alert alert-border-info" >
                                  <div class="d-flex">
                                      <div class="icon">
                                          <i class="icon fe fe-credit-card"></i>
                                      </div>
                                      <div class="content">
                                          <strong>{{auth_user.user.sector}}</strong>


                                      </div>
                                  </div>
                              </div>
                </div>
              </div>

                <!-- <div class="col-lg-4 col-md-6">
                    <div class="card table-card shadow mb-4">
                        <div class="card-body">
                            <div class="pb-2">
                              <router-link :to="{ path: '/my-funds'}">
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-database"></i>
                                    </div>
                                </div>
                              </router-link>
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">Wallet</p>
                                <h1 class="fw-400"> <i class="mdi mdi-currency-ngn"></i>{{wallet.amount  | numeral('0,0.00')}}</h1>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="col-lg-4 col-md-6">
                    <div class="card table-card shadow mb-4">
                        <div class="card-body">
                            <div class="pb-2">
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-users"></i>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">Dependents</p>
                                <h1 class="fw-400">{{dependents.length}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="card table-card shadow mb-4">
                        <div class="card-body">
                            <div class="pb-2">
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-activity"></i>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">Facility to Access Care</p>
                                <h1 class="fw-400">{{healthFacility.agency_name}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="card table-card shadow mb-4">
                        <div class="card-body">
                            <div class="pb-2">
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-briefcase"></i>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">MDA</p>
                                <h1 class="fw-400">{{auth_user.user.place_of_work}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">

                             <div class="col-md-12 m-b-30">
                                 <h5> <i class="fe fe-users"></i>{{dependents.length}} Dependents</h5>
                                 <div class="table-responsive">
                                     <table class="table align-td-middle table-card">
                                         <thead style="background: #f8fafc;">
                                         <tr>
                                             <th class="table-th">Avatar</th>
                                             <th class="table-th">Name</th>
                                             <th class="table-th">ID Number</th>
                                             <th class="table-th">Contact</th>
                                             <th class="table-th">Gender</th>
                                             <th class="table-th">Relationship</th>
                                         </tr>
                                         </thead>
                                         <tbody>
                                         <tr v-for="dependent in dependents" v-bind:key="dependent.id">
                                             <td>
                                               <vue-initials-img :name="dependent.firstname+' '+dependent.lastname" class="img-thumbnail" size="25"  v-if="dependent.image == null "/>

                                                 <div class="avatar avatar-md " v-if="dependent.image != null ">
                                                   <img :src="`https://claimify-api.hayokmedicare.ng/image/${dependent.image}`"
                                                         class="avatar-img avatar-lg rounded"
                                                         alt="">
                                                  </div>

                                             </td>
                                             <td>
                                               {{dependent.firstname}} {{dependent.middlename}} {{dependent.lastname}}

                                             </td>
                                             <td>{{dependent.id_card_number}}</td>
                                             <td>{{dependent.phone_number}}</td>
                                             <td>{{dependent.gender}}</td>
                                             <td>{{dependent.relationShipType}}</td>


                                         </tr>

                                         </tbody>
                                     </table>

                                 </div>
                             </div>

                <div class="col-md-12 m-b-30">
                    <h5> <i class="fe fe-alert-circle"></i> Complaints</h5>
                    <div class="table-responsive">
                        <table class="table align-td-middle table-card">
                            <thead style="background: #f8fafc;">
                            <tr>
                                <th class="table-th">Complain Number</th>
                                <th class="table-th">Title</th>
                                <th class="table-th">Type</th>
                                <th class="table-th">Status</th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="complaint in complaints" v-bind:key="complaint.id">
                              <td>122333932</td>
                                <td>{{complaint.title}}</td>
                                <td>{{complaint.type}}</td>
                                <td>{{complaint.status}}</td>
                            </tr>

                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>

    </section>
</main>


    </div>

</template>

<script>
import Navbar from '@/views/Navbar.vue'

export default {
  components: {
     Navbar
  },
  data(){
    return{
      auth_user:"",
      dependents:"",
      healthFacility:"",
      complaints:"",
      user:null

    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/user/zam/${this.user.id}`)
                .then(response => {
                    this.auth_user = response.data
                    console.log(response)
          // get facility
          this.axios.get(`/api/v1/auth/userprovider/${this.auth_user.user.provider_id}`)
                      .then(response => {
                          this.healthFacility = response.data.user
                          console.log(this.healthFacility)
                      })
                      .catch(() => {
                          // console.error(error);
                      })
          //end of facility
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    getDependents(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/allDependantUser/${this.user.id}`)
                  .then(response => {
                      this.dependents = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getPlan(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/userSubscribedPlan`)
                  .then(response => {
                      this.myplan = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getComplaints(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/complaints/${this.user.id}`)
                  .then(response => {
                      this.complaints = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getWallet(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/getUserWallet`)
                  .then(response => {
                      this.wallet = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    }

  },
  created(){
    this.getDependents()
    this.getComplaints()
    this.getPlan()
    this.getWallet()
  }
}
</script>
<style lang="css" scoped>
  .spacer-top{
    margin-top:10px;
  }
</style>
